import angular from 'angular';
import uiRouter from 'angular-ui-router';
import myLoansFiltersComponent from './myLoansFilters.component';

let myLoansFiltersModule = angular.module('loansFilters', [
  uiRouter
])

.component('myLoansFilters', myLoansFiltersComponent)

.name;

export default myLoansFiltersModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/myLoansFilters/myLoansFilters.js